export const APP_NAME = process.env.REACT_APP_APP_NAME || 'Program Tags';

export const FIELD_TYPES = [
  { value: 'text', label: 'Text' },
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'number', label: 'Number' },
  { value: 'country', label: 'Country' },
  { value: 'select', label: 'Dropdown' },
  { value: 'radio', label: 'Radio Buttons' },
  { value: 'checkbox', label: 'Checkboxes' },
  { value: 'textarea', label: 'Text Area' },
  { value: 'date', label: 'Date' },
  { value: 'file', label: 'File Upload' },
];

export const CHECK_IN_STATUS = {
  PENDING: 'pending',
  CHECKED_IN: 'checked_in',
  CHECKED_OUT: 'checked_out',
};

export const CHECK_IN_STATUS_LABELS = {
  pending: 'Pending',
  checked_in: 'Checked In',
  checked_out: 'Checked Out',
};

export const CHECK_IN_STATUS_COLORS = {
  pending: 'warning',
  checked_in: 'success',
  checked_out: 'info',
};

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  EVENT_ADMIN: 'event_admin',
  USHER: 'usher',
  FRONT_DESK: 'front_desk',
  ATTENDEE: 'attendee',
};

export const USER_ROLE_LABELS = {
  super_admin: 'Super Administrator',
  event_admin: 'Event Administrator',
  usher: 'Event Usher',
  front_desk: 'Front Desk Staff',
  attendee: 'Attendee',
};

export const USER_ROLE_DESCRIPTIONS = {
  super_admin: 'Full system access, create event admins, manage all events',
  event_admin: 'Create events, manage assigned events, create staff users',
  usher: 'Check-in attendees, basic event management',
  front_desk: 'Register attendees, check-in, print badges',
  attendee: 'Self-registration only',
};

// Permission helpers
export const ROLE_PERMISSIONS = {
  super_admin: {
    canCreateEvents: true,
    canEditEvents: true,
    canCreateUsers: true,
    canCreateAdmins: true,
    canDeleteAnyEvent: true,
    canDeleteAnyUser: true,
    canSeeAllEvents: true,
    canSeeAllUsers: true,
    canImportExport: true,
  },
  event_admin: {
    canCreateEvents: true,
    canEditEvents: true,
    canCreateUsers: true,
    canCreateAdmins: false,
    canDeleteAnyEvent: false,
    canDeleteAnyUser: false,
    canSeeAllEvents: false,
    canSeeAllUsers: false,
    canImportExport: true,
  },
  usher: {
    canCreateEvents: false,
    canEditEvents: false,
    canCreateUsers: false,
    canCreateAdmins: false,
    canDeleteAnyEvent: false,
    canDeleteAnyUser: false,
    canSeeAllEvents: false,
    canSeeAllUsers: false,
    canImportExport: false,
  },
  front_desk: {
    canCreateEvents: false,
    canEditEvents: false,
    canCreateUsers: false,
    canCreateAdmins: false,
    canDeleteAnyEvent: false,
    canDeleteAnyUser: false,
    canSeeAllEvents: false,
    canSeeAllUsers: false,
    canImportExport: false,
  },
  attendee: {
    canCreateEvents: false,
    canEditEvents: false,
    canCreateUsers: false,
    canCreateAdmins: false,
    canDeleteAnyEvent: false,
    canDeleteAnyUser: false,
    canSeeAllEvents: false,
    canSeeAllUsers: false,
    canImportExport: false,
  },
};

export const BADGE_TEMPLATE_TYPES = [
  { value: 'standard', label: 'Standard' },
  { value: 'vip', label: 'VIP' },
  { value: 'speaker', label: 'Speaker' },
];

export const BADGE_LAYOUTS = [
  { value: 'standard', label: 'Standard', description: 'Classic layout with logo and QR code' },
  { value: 'modern', label: 'Modern', description: 'Clean, minimalist design' },
  { value: 'minimal', label: 'Minimal', description: 'Simple layout, text-focused' },
  { value: 'corporate', label: 'Corporate', description: 'Professional business style' },
  { value: 'executive', label: 'Executive', description: 'Premium design with elegant typography' },
  { value: 'creative', label: 'Creative', description: 'Vibrant design with artistic elements' },
  { value: 'tech', label: 'Tech', description: 'Futuristic design for tech events' },
  { value: 'conference', label: 'Conference', description: 'Professional conference layout' },
  { value: 'networking', label: 'Networking', description: 'Social-focused design with emphasis on contact info' },
  { value: 'premium', label: 'Premium', description: 'Luxury design with gold accents' },
];
